import { SectionLabel, Reveal } from "../landing/shared";

const BULLETS = [
  "You complete a mortgage application and the required authorizations so the review is based on real information",
  "Josh walks through the whole transaction with you — not one number in isolation",
  "You leave the call with a clearer next step, whether that step is apply, prepare, or wait",
];

export default function Objections() {
  return (
    <section className="py-24 lg:py-36 px-6 lg:px-10" data-testid="objections-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14">
        <Reveal>
          <SectionLabel n="005" text="STILL DECIDING" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-8 leading-tight">
            Still on the fence?
          </h2>
          <div className="space-y-5 text-white/60 text-[15px] leading-[1.8]">
            <p>
              Maybe you're thinking, "I already used my VA benefit," or "I already own a home, so there's nothing to
              look at." That's exactly the situation worth examining rather than assuming. Remaining entitlement,
              an existing property, a move-up plan — these are questions with real answers, and only a full review
              of your information can answer them for your situation.
            </p>
            <p>
              Or maybe it's "what if I'm not ready?" Then the honest answer is prepare — and you'll leave the
              conversation knowing exactly what would need to change before the timing works. No promises about
              outcomes, just clarity about where you actually stand.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="border border-[#0162CA]/30 bg-[#0162CA]/[0.05] p-8 lg:p-10 h-full">
            <p className="font-mono-strict text-[11px] tracking-[0.28em] text-[#0162CA] mb-8">
              HERE'S WHAT HAPPENS WHEN YOU APPLY:
            </p>
            <ul className="space-y-6">
              {BULLETS.map((b, i) => (
                <li key={i} className="flex gap-4 text-white/80 text-[15px] leading-relaxed" data-testid={`objection-bullet-${i + 1}`}>
                  <span className="text-[#0162CA] font-bold shrink-0">→</span>
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
